"use client";

import { mutate } from "swr";
import { ContestAPI } from "@/restapi/contest";

export type ContestUpdateRequest = {
  id: number;
  title: string;
  description: string | null;
  startDate: string | null;
  scoringStartDate: string | null;
  contestEndDate: string | null;
  isPublished: boolean;
  groupId: number;
};

export const useContestUpdate = () => {
  const submit = async (request: ContestUpdateRequest) => {
    try {
      // APIにPOSTリクエストを送信してデータを取得
      const newContestStore = await ContestAPI.update(request);

      // キャッシュを更新
      mutate(
        `contest-update-${newContestStore.id}`,
        newContestStore,
        false
      );

      // 一覧系の再検証: useContestSearch が生成する key は "contest-list?{params}&page={page}"
      mutate((key) => typeof key === "string" && key.startsWith("contest-list?"));

      return newContestStore;
    } catch (err) {
      console.error("Failed to submit group store", err);
      throw err; // エラー処理
    }
  };

  return {
    submit,
  };
};
